import React from 'react';
import { createSvgIcon } from '@material-ui/core';

export default createSvgIcon(
  <path d="M11.9999 1.92004C6.43576 1.92004 1.91992 6.43588 1.91992 12C1.91992 17.5642 6.43576 22.08 11.9999 22.08C17.5641 22.08 22.0799 17.5642 22.0799 12C22.0799 6.43588 17.5641 1.92004 11.9999 1.92004ZM9.98392 17.04L5.95192 13.008L7.3732 11.5868L9.98392 14.1874L16.6266 7.54468L18.0479 8.97604L9.98392 17.04Z" />,
  'QualityMedium'
);
